import { AppConfigService } from "../../app-config/app-config.service";
import { ParticipantDTO } from "app/core/models/participant-dto";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  	providedIn: 'root'
})

export class HttpAddParticipantService {

    public readonly URL: string;

	constructor(
		private http: HttpClient,
        private configSvc: AppConfigService
	) {
        this.URL = this.configSvc.settings.nodeUrl + 'participants';
    }

    public addParticipant$(
        newParticipantID: string,
        newParticipantName: string,
        newParticipantTargetURL: string,
        newParticipantProtocols: string[]
    ): Observable<ParticipantDTO> {

        const headers = new HttpHeaders({
			'x-api-key': this.configSvc.settings.participantsAPIKey
		});

        const body = {
            "id": newParticipantID,
            "name": newParticipantName,
            "targetUrl": newParticipantTargetURL,
            "supportedProtocols": newParticipantProtocols
        }

        return this.http.post<ParticipantDTO>(
            this.URL,
            body,
            { headers }
        );

    }

}